const state = () => ({
  members: 10000,

  activeFeature: [
    'introductions'
  ],

  features: [{
    name: 'introductions',
    price: 1.25
  }, {
    name: 'collaboration',
    price: 1.5
  }, {
    name: 'communities',
    price: 1.75
  }]
})

const getters = {
  members: state => state.members,
  activeFeature: state => state.activeFeature,
  features: state => state.features,
  getTotalPrice: (state) => {
    return state.features.reduce((total, feature) => {
      if (state.activeFeature.indexOf(feature.name) >= 0) {
        return total + feature.price
      }

      return total
    }, 0)
  }
}

const mutations = {
  SET_MEMBERS (state, members) {
    state.members = members
  },
  SET_FEATURE (state, feature) {
    const featureIndex = state.activeFeature.indexOf(feature)

    if (featureIndex < 0) {
      state.activeFeature.push(feature)
      return
    }

    if (state.activeFeature.length > 1) {
      state.activeFeature.splice(featureIndex, 1)
    }
  }
}

const actions = {
  setMembers ({ commit }, members) {
    commit('SET_MEMBERS', members)
  },
  setFeature ({ commit }, feature) {
    commit('SET_FEATURE', feature)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
